import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import bookicon1 from '../../assets/images/resource/book-icon-1.png';
import 'swiper/swiper.min.css';
import SwiperCore, { Navigation, Autoplay } from 'swiper';
import { useContent } from '../../services';
import analytics from '../../services/analytics';

SwiperCore.use([Navigation, Autoplay]);

// Map slide image filenames to their require paths
const slideImages = {
  'slider-1.jpg': require('../../assets/images/main-slider/slider-1.jpg'),
  'slider-2.jpg': require('../../assets/images/main-slider/slider-2.jpg'),
  'slider-3.jpg': require('../../assets/images/main-slider/slider-3.jpg'),
};

function Banner() {
    const { data: banner, loading } = useContent('homeBanner');

    if (loading || !banner) return null;

    const { slides, cta, bookButton } = banner;

    return (
        <Swiper
            className="banner-section banner-section-coustm"
            loop={true}
            autoplay={{ delay: 3000 }}
            spaceBetween={50}
            slidesPerView={1}
            navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
        >
            <div className="banner-container">
                <div className="banner-slider">
                    <div className="swiper-wrapper">
                        {slides.map((slide) => (
                            <SwiperSlide
                                key={slide.id}
                                className="swiper-slide slide-item img-fluid"
                                style={{ backgroundImage: `url(${slideImages[slide.image]})` }}
                            >
                                <div className="auto-container">
                                    <div className="content-box">
                                        <div className="content">
                                            <div className="clearfix">
                                                <div className="inner">
                                                    <div className="subtitle">
                                                        <span>{slide.subtitle}</span>
                                                    </div>
                                                    <div className="pattern-image">
                                                        <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                                                    </div>
                                                    <h1><span>{slide.headingLine1}<br />{slide.headingLine2}</span></h1>
                                                    <div className="text">{slide.text}</div>
                                                    <div className="links-box wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                                        <div className="link">
                                                            <Link to={cta.link} className="theme-btn btn-style-two clearfix">
                                                                <span className="btn-wrap">
                                                                    <span className="text-one">{cta.label}</span>
                                                                    <span className="text-two">{cta.label}</span>
                                                                </span>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </div>
                </div>
            </div>
            <div className="swiper-button-prev">
                <span className="fal fa-angle-left"></span>
            </div>
            <div className="swiper-button-next">
                <span className="fal fa-angle-right"></span>
            </div>
            <div className="book-btn">
                <Link to="/reservation" className="theme-btn" onClick={() => analytics.trackReservationClick('hero_banner')}>
                    <span className="icon">
                        <img src={bookicon1} alt="" title="" />
                    </span>
                    <span className="txt">{bookButton.label}</span>
                </Link>
            </div>
        </Swiper>
    );
}

export default Banner;
